import { render, staticRenderFns } from "./NoteShareSidebar.vue?vue&type=template&id=9278beb0"
import script from "./NoteShareSidebar.vue?vue&type=script&lang=js"
export * from "./NoteShareSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports